import * as React from 'react';
import {FrameMeta} from "../problem-domain/frame";
import {Link} from "react-router-dom";
import {pathToLinks} from "../tagUtils";
import {Menus} from "../Menu";
import {Button} from "react-bootstrap";

export function renderPath(path: string[], frameIndex: FrameMeta, isLexicon,
                           disableLinks = false) {
    const linkChain = pathToLinks(path, frameIndex, isLexicon);
    return (
        <div className="lexicon-path">
            {linkChain.map(x => x.link !== null ?
                // when frame available
                (<span className="path-node">
                        <Link className={disableLinks ? "disable-links" : undefined}
                              to={x.link}>{x.name}</Link></span>) :
                // when frame unavailable
                (<span className="path-node">
                        <a className="frame-unavailable"
                           onClick={Menus.newFrameClicked}>
                        {x.name}</a></span>))
            }
        </div>
    );
}


export class HiddenBlock extends React.Component<any, any> {
    constructor(props) {
        super(props);
        this.state = {hidden: true};
    }

    render() {
        const hidden = this.state.hidden && (this.props.children.length > 5);
        const end = hidden ? 5 : undefined;
        console.log("state", this.state.hidden);
        console.log("children count", this.props.children);
        console.log(hidden);
        return (<div>
            {...this.props.children.slice(0, end)}
            {hidden &&
            <a onClick={() => {
                this.setState({hidden: !this.state.hidden})
            }}>Show all patterns ({this.props.children.length - 5} rest)</a>
            }
        </div>);
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/utils.tsx